<template>
    <div class="instructors">
        <table-control :paging="ctrl.paging" :search="true" v-model="search"></table-control>

        <el-table class="table-responsive table-flush"
                :show-header="false"
                :data="ctrl.rows">

            <el-table-column width="72">
                <template v-slot="{row}">
                    <span class="avatar rounded-circle">
                        <img :src="row.avatar">
                    </span>
                </template>
            </el-table-column>

            <el-table-column>
                <template v-slot="{row}">
                    <h4 class="mb-0">
                        {{ row.name }}
                    </h4>
                    <small v-if="row.owner">
                        {{ row.owner.name }}
                    </small>
                    <small v-if="row.entity">
                        / {{ row.entity.name }}
                    </small>
                </template>
            </el-table-column>

            <el-table-column align="right" class-name="actions">
                <template v-slot="{row}">
                    <div class="m-1">

                        <base-button type="primary" size="sm" v-if="enrolled(row)">
                            {{ $t('common.instructor') }}
                        </base-button>

                        <base-button type="white" size="sm" v-else @click.prevent="addMember(row)">
                            {{ $t('common.enroll') }}
                        </base-button>

                    </div>
                </template>
            </el-table-column>
            
        </el-table>

        <table-pagination :paging="ctrl.paging"></table-pagination>

        <div class="text-center">
            <base-button type="link" class="ml-auto" @click="modal.show = false">
                {{ $t('common.close') }}
            </base-button>
        </div>
    </div>
</template>

<script>
    import CrudController from '@trax/classes/CrudController'
    import UserMapping from '../../accounts/users/UserMapping'

    export default {

        props: {

            cohort: {
                type: Object,
                required: true
            },

            instructors: {
                type: Array,
                required: true
            },

            modal: {
                type: Object,
                default: null
            },
        },

        data() {
            let mapping = new UserMapping()
            return {
                loaded: false,
                ctrl: new CrudController({
                    endpoint: '/trax/api/front/users',
                    mapData: mapping.mapData,
                    unmapData: mapping.unmapData,
                    paging: {
                        perPage: 10,
                        total: 0
                    },
                    query: {
                        sort: ['lastname'],
                        relations: ['owner', 'entity'],
                        accessors: ['permissions'],
                        filters: {
                            active: true,
                            $or: [
                                { instructor: true },
                                { admin: true }
                            ]
                        }
                    }
                }),
                search: '',
            }
        },

        created() {
            this.ctrl.init(this, 'ctrl').then(resp => {
                this.loaded = true
            })
        },

        watch: {
            search(val) {
                this.ctrl.filterMore({ simpleSearch: val })
            }
        },

        methods: {
            enrolled(user) {
                return this.instructors.find(member => member.id == user.id) != undefined
            },

            addMember(user) {
                axios.post('/astral/api/front/cohorts/'+this.cohort.id+'/members/'+user.id, {
                    role: 'instructor',
                    referent: false
                }).then(resp => {
                    this.$emit('change');
                })
                .catch(err => {
                    this.$auth.handleErrorVm(err, this)
                })        
            },
        }
    }
</script>

<style scoped>

    .instructors >>> th,
    .instructors >>> td {
        padding-right: 0;
    }
    .instructors >>> th.actions,
    .instructors >>> td.actions {
        padding-right: 1.5rem;
    }
    .instructors >>> .table-control form {
        width: 100%;
    }
    .instructors >>> .card-footer {
        background-color: transparent;
    }
    
</style>
